export default __webpack_public_path__ + "static/media/Group 5180.17f0e6c1.svg";